import ArticleLayout from '@/components/feature/ArticleLayout';

export default function ShoesArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Shoes: Complete Buying Guide &amp; Best Finds for 2026</title>
      <meta name="description" content="Complete guide to Superbuy Spreadsheet shoes — discover the best sneaker finds, footwear categories, sizing tips, and curated shoe collections. Updated 2026 with the latest shoe discoveries." />
      <meta name="keywords" content="superbuy spreadsheet shoes, superbuy sheet shoes, superbuy sneaker spreadsheet, best superbuy shoes, superbuy footwear guide, superbuy spreadsheet footwear finds" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-shoes`} />
      <ArticleLayout slug="superbuy-spreadsheet-shoes" />
    </>
  );
}